module.exports = __webpack_public_path__ + "img/4xperweek.dbcfa0a9.svg";